import React, { 
  ComponentProps, 
  //CSSProperties, 
  FocusEvent, 
  //ChangeEvent, 
  useImperativeHandle, 
  useRef, 
  useState 
} from "react";
import "./input-field.style.css";

export interface IInputField extends ComponentProps<"input"> {
  placeholder?: string,
  className?: string,
  //type?: string,
  //maxLength?: number,
  //name?: string,
  //role?: string,
  //value?: string | number,
  //style?: CSSProperties,
  //disabled?: boolean;
  //onChange?: (e: ChangeEvent<HTMLInputElement>) => void,
  ref?: React.RefObject<HTMLInputElement | null> | undefined,
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void,
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void,
}

export default function InputField(props: IInputField): React.JSX.Element {
  const { placeholder = "", className, onBlur, onFocus, ref, ...rest } = props;

  const node = useRef<HTMLInputElement | null>(null);
  const [fieldPlaceholder, setFieldPlaceholder] = useState<string>(placeholder);

  /**
   * React refs refer to DOM elements not to custom compoents.
   * To pass a ref from a custom component to the DOM component of a child
   * (aka nested) component, we previously had to use React.forwardRef.
   *
   * However, React.forwardRef is soon to be deprecated,
   * and the React guys says we can now use a 'ref' prop directly just like other props.
   * @see: https://react.dev/reference/react/forwardRef
   * @see: https://react.dev/blog/2024/12/05/react-19#ref-as-a-prop
   *
   * Also, in addition to the ref passed from the parent component,
   * we are also using an inner ref which is also needed by this component.
   * To have both refs (passed and internal) refer to the same DOM element,
   * we use this useImperativeHandle trick.
   *
   * > Call the useImperativeHandle hook on the outer ref
   * > (which is being forwarded to the child component)
   * > and pass a function that returns the current property of the inner ref,
   * > which is the value that will be set to the current property of the outer ref.
   *
   * > Remember to list any dependencies of the function that returns the ref value,
   * > similar to useEffect.
   *
   * @see: https://stackoverflow.com/a/77055616/1743192
   */
  useImperativeHandle(ref, () => node.current!, []);

  function handleInputBlur(e: FocusEvent<HTMLInputElement>) {
    e.preventDefault();
    setFieldPlaceholder(placeholder);

    if(typeof onBlur === "function") {
      onBlur(e);
    }
  }

  function handleInputFocus(e: FocusEvent<HTMLInputElement>) {
    e.preventDefault();
    setFieldPlaceholder("");

    if(typeof onFocus === "function") {
      onFocus(e);
    }
  }

  return (
    <input ref={node}
      className={`form-control input-field ${className ? className : ""}`}
      placeholder={fieldPlaceholder}
      onFocus={handleInputFocus}
      onBlur={handleInputBlur}
      {...rest}
    />
  );
}
